export enum RugbyUnionTurnoverAttribute {
  KnockOn = 2966,
  ForwardPass = 2967,
  Offside = 2968,
  Intercepted = 2969,
  ForcedIntoTouch = 2970,
  LostInRuck = 2971,
  LostInMaul = 2972,
  LostInScrum = 2973,
}
